import React from "react";
import Index from "./index";
import CustomCard from "../../../shared/Card/CustomCard";
import { CustomInput } from "../../../shared/Input/AllInputs";
import PrimaryButton from "../../../shared/Button/PrimaryButton";
import { CustomEditor } from "../../../shared/Input/CustomEditor";

export default function TermsAndConditions() {
    let { termsAndCondtionsData, setTermsAndConditionsData, updateTermsAndCondtionsData } = Index();

    return (
        <CustomCard title={"Terms of service"} backable={false}>
            <CustomInput
                key="heading"
                label="Header"
                name="heading"
                value={termsAndCondtionsData?.heading}
                onChange={(e) => setTermsAndConditionsData({ ...termsAndCondtionsData, heading: e.target.value })}
            />
            <CustomEditor
                name="paragraphText"
                label="Privacy policy"
                value={termsAndCondtionsData?.paragraphText}
                onTextChange={(e) => setTermsAndConditionsData((prev) => ({ ...prev, paragraphText: e.htmlValue }))}
                style={{ height: "320px" }}
            />
            <div className="flex justify-content-end">
                <PrimaryButton label={"Update"} extraClassName={"w-3"} onClick={updateTermsAndCondtionsData} />
            </div>
        </CustomCard>
    );
}
